import React from 'react';
import { Skeleton } from 'antd';
import { Layer } from '../styled';

function TableSkeleton() {
  return (
    <Layer>
      <Skeleton
        active
        title={false}
        loading
        paragraph={{ rows: 10 }}
      />
    </Layer>
  );
}

export default TableSkeleton;
